import { render, staticRenderFns } from "./CampaignItemsEditor.vue?vue&type=template&id=8681813a&scoped=true&"
import script from "./CampaignItemsEditor.vue?vue&type=script&lang=js&"
export * from "./CampaignItemsEditor.vue?vue&type=script&lang=js&"
import style0 from "./CampaignItemsEditor.vue?vue&type=style&index=0&id=8681813a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8681813a",
  null
  
)

export default component.exports